<app-header></app-header>
<!--Breadcrumb-->
<div>
    <div class="bannerimg cover-image bg-background3 car-detail-header" data-image-src="assets/images/banners/banner2.jpg">
        <div class="header-text mb-0">
            <div class="container">
                <div class="text-center text-white ">
                    <h2 class="mb-0">Inspection Report</h2>

                </div>
            </div>
        </div>
    </div>
</div>
<!--/Breadcrumb-->

<!--Faq section-->
<section class="sptb">
    <div class="container">
        <div class="row">

            <div class="card m-b-20">
                <div class="card-header click-show">
                    <h3 class="card-title">Basic Information </h3><span class="plusminus">+</span>
                </div>
                <div class="card-body inspection-heading">
                    <form [formGroup]="basicInfoFormGroup">
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Make</label>
                                    <input type="text" class="form-control" id="name1" value="{{brandNameBasic}}" placeholder="Brand Name" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Model</label>
                                    <input type="text" class="form-control" id="name1" value="{{modelNameBasic}}" placeholder="Model Name" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Unique Id</label>
                                    <input type="text" class="form-control" id="name1" value="{{uidNameBasic}}" placeholder="UID" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">RTO</label>
                                    <input type="text" class="form-control" id="name1" value="{{rtoNameBasic}}" placeholder="UID" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">First Name</label>
                                    <input type="text" class="form-control" id="name1" value="{{firstNameBasic}}" placeholder="First Name" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Last  Name</label>
                                    <input type="text" class="form-control" id="name1" value="{{lastNameBasic}}" placeholder="Last  Name" readonly>
                                </div>
                            </div>
                            <!--div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Address</label>
                                    <input type="text" class="form-control" id="name1" value="{{AddressBasic}}" placeholder="Address" readonly>
                                </div>
                            </div-->
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">City</label>
                                    <input type="text" class="form-control" id="name1" value="{{cityBasic}}" placeholder="City" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">State</label>
                                    <input type="text" class="form-control" id="name1" value="{{stateBasic}}" placeholder="State" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Postal Index</label>
                                    <input type="text" class="form-control" id="name1" value="{{postalBasic}}" placeholder="Postal Index" readonly>
                                </div>
                            </div>

                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Email</label>
                                    <input type="text" class="form-control" id="name1" value="{{emailBasic}}" placeholder="Email" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1"> Phone </label>
                                    <input type="text" class="form-control" id="name1" value="{{phoneBasic}}" placeholder=" Phone " readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Car Registration Year </label>
                                    <input type="text" class="form-control" id="name1" value="{{manufacturingYear}}" placeholder=" Car Registration Year" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">RC Expiry </label>
                                    <input type="date" formControlName="basicInfoRCExpiry" class="form-control" id="name1" value="{{rCExpiryBasic}}" placeholder="RC Expiry">
                                </div>
                            </div>
                            <div class="form-group col-md-4"  style="display:none">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Mileage /Odometer </label>
                                    <input type="number" formControlName="basicInfoMileage" class="form-control" id="name1" placeholder=" Mileage /Odometer">
                                </div>
                                <div *ngIf="basicInfoFormGroup.get('basicInfoMileage').errors && isBasicInfoSubmit">
                                <span style="color: red;">Enter valid mileage</span>
                                </div>
                            </div>

                            <div class="form-group col-md-4" style="display:none">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">VIN  </label>
                                    <input type="text" formControlName="basicInfoVin" class="form-control" id="name1" placeholder="VIN ">
                                </div>
                                <div *ngIf="basicInfoFormGroup.get('basicInfoVin').errors && isBasicInfoSubmit">
                                <span style="color: red;">Enter valid vin</span>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4" class="form-label">Select Keys</label>
                                <!-- <select formControlName="basicInfoKeys" class="form-control " >
                                    <optgroup label="Select Keys">
                                        <option value="0">--Select--</option>
                                        <option value="Keys">Keys</option>
                                        <option value="Keyless">Keyless</option>
                                    </optgroup>
                                </select> -->
                                <ng-select 
                                name="id" 
                                [multiple]="true"
                                [items]="keysList" 
                                formControlName="basicInfoKeys"                                 
                                bindValue="id" 
                                bindLabel="name" 
                                placeholder="Select"
                                required 
                                [closeOnSelect]="false">
                                </ng-select>
                                <div *ngIf="basicInfoFormGroup.get('basicInfoKeys').errors && isBasicInfoSubmit">
                                <span style="color: red;">Select valid keys type</span>
                                </div>
                            </div>
                            <div class="form-group col-md-4" *ngIf="fuelTypeList.length>0">
                                <label for="inputEmail4" class="form-label">Fuel Type</label>
                                <!-- <select formControlName="basicInfoFuelType" class="form-control "  placeholder="Select"> 
                                    <option value="0">--Select--</option>
                                    <option value="{{fuelType.id}}" *ngFor="let fuelType of fuelTypeList">{{fuelType.name}}</option>
                                </select> -->
                                <ng-select 
                                name="id" 
                                [multiple]="true"
                                [items]="fuelTypeList" 
                                [(ngModel)]="basicInfoFuelTypeModel"
                                formControlName="basicInfoFuelType"                                 
                                bindValue="id" 
                                bindLabel="name" 
                                placeholder="Select"
                                required 
                                [closeOnSelect]="false">
                                    <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.basicInfoFuelTypeModel"/> {{item.name}}
                                    </ng-template> -->
                                </ng-select>
                                <div *ngIf="basicInfoFormGroup.get('basicInfoFuelType').errors && isBasicInfoSubmit">
                                <span style="color: red;">Select valid fuel type</span>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Variant </label>
                                    <input type="text" class="form-control" id="name1"  value="{{variantBasic}}" placeholder="Variant" readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="exampleInputEmail1">Okshan Value  </label>
                                    <input type="text" class="form-control" id="name1"  value="{{fmvBasic}}" placeholder=" Okshan Value " readonly>
                                </div>
                            </div>
                            <div class="form-group col-md-4" style="display:none;">
                                <div class="form-group">
                                <label for="inputEmail4" class="form-label">Documentation Charges</label>
                                <input type="number" formControlName="basicInfoDocCharges" class="form-control" id="inputEmail5" placeholder="Documentation Charges">
                                </div>
                                <div *ngIf="basicInfoFormGroup.get('basicInfoDocCharges').errors && isBasicInfoSubmit">
                                <span style="color: red;">Enter valid documentation charges</span>
                                </div>
                            </div> 
                            <!--div class="form-group col-md-4">
                             <div class="form-group">
                                <label class="form-label">Seating</label>
                                <input type="number" formControlName="basicInfoSeating"  class="form-control" id="name2">
                             </div>
                           </div-->
                           <div class="form-group col-md-4">
                             <div class="form-group">
                                <label class="form-label">KM Driven</label>
                                <input type="number" formControlName="basicInfoKMDriven"   class="form-control" id="name2">
                             </div>
                           </div>
                           <div class="form-group col-md-4" style="display:none">
                             <div class="form-group">
                                <label class="form-label">Engine Displacement (cc)</label>
                                <input type="number" formControlName="basicInfoEngineDisplacement"  class="form-control" id="name2">
                             </div>
                           </div>
                           <div class="form-group col-md-4"  style="display:none">
                             <div class="form-group">
                                <label class="form-label">Max Torque (nm@rpm)</label>
                                <input type="text" formControlName="basicInfoMaxTorque" class="form-control" id="name2">
                             </div>
                           </div>
                           <div class="form-group col-md-4"  style="display:none">
                             <div class="form-group">
                                <label class="form-label">Boot Space (Litres)</label>
                                <input type="number" formControlName="basicInfoBootSpace" class="form-control" id="name2">
                             </div>
                           </div>
                           <div class="form-group col-md-4"  style="display:none">
                             <div class="form-group">
                                <label class="form-label">Max Power (bhp@rpm)</label>
                                <input type="text" formControlName="basicInfoMaxPower" class="form-control" id="name2">
                             </div>
                           </div>
                           <div class="form-group col-md-4"  style="display:none">
                             <div class="form-group">
                                <label class="form-label">Fuel Tank Capacity</label>
                                <input type="text" formControlName="basicInfoFuelTankCapacity" class="form-control" id="name2">
                             </div>
                           </div>
                           <div class="form-group col-md-4">
                             <div class="form-group">
                                <label class="form-label">Body Type</label>
                                <!-- <select multiple  formControlName="basicInfoBodyType" class="form-control w-100" data-placeholder="Select">
                                <optgroup label="">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let type of bodyTypetList" value="{{type.id}}">{{type.name}}</option>                                   
                                </optgroup>
                               </select> -->
                               <ng-select 
                                name="id" 
                                [multiple]="true"
                                [items]="bodyTypetList" 
                                [(ngModel)]="basicInfoBodyTypeModel"
                                formControlName="basicInfoBodyType"                                 
                                bindValue="id" 
                                bindLabel="name" 
                                placeholder="Select"
                                required 
                                [closeOnSelect]="false">
                                    <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.basicInfoBodyTypeModel"/> {{item.name}}
                                    </ng-template> -->
                                </ng-select>
                             </div>
                           </div>
                           <div class="form-group col-md-4">
                             <div class="form-group">
                                <label class="form-label">Transmission Type</label>
                                <!-- <select  formControlName="basicInfoTransmissionType" class="form-control w-100" data-placeholder="Select">
                                <optgroup label="">
                                    <option value="0">--Select--</option>
                                    <option value="1">AMT</option>
                                    <option value="2">Automatic</option>
                                    <option value="3">Manual</option>
                                </optgroup>
                            </select> -->
                            <ng-select 
                                name="id" 
                                [multiple]="true"
                                [items]="transmissionTypeList" 
                                formControlName="basicInfoTransmissionType"                                 
                                bindValue="id" 
                                bindLabel="name" 
                                placeholder="Select"
                                required 
                                [closeOnSelect]="false">
                            </ng-select>
                             </div>
                           </div>


                            <div class=" col-sm-12 col-md-12 " *ngIf="inspectionEditStatus">
                                <button *ngIf="basicInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveBasicInfo(basicInfoFormGroup.value)">{{basicInfoSaveBtnLbl}}</button>
                                <button *ngIf="basicInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{basicInfoSaveBtnLbl}}...</button>
                            </div>

					</div>
                    </form>
                
            </div>
        </div>
						
						 <div class="card m-b-20">
                                <div class="card-header">
                                    <h3 class="card-title">Car Images (Upload minimum 4 pictures)</h3>
                                </div>
                                <div class="card-body">
                                    <form class="form-horizontal">
                                        <div class="form-group col-md-12">
                                            <div class=" card-body">
                                                <div class="row">       

													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 1    <a data-toggle="modal" data-target="#changeDoc1"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic1Basic!=''" (click)="deletePic('pic_1')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal1').modal('show');" *ngIf="pic1Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic1Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic1Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>		
													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 2    <a data-toggle="modal" data-target="#changeDoc2"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic2Basic!=''" (click)="deletePic('pic_2')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal2').modal('show');" *ngIf="pic2Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic2Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic2Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>	
													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 3    <a data-toggle="modal" data-target="#changeDoc3"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic3Basic!=''" (click)="deletePic('pic_3')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal3').modal('show');" *ngIf="pic3Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic3Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic3Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>		
													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 4    <a data-toggle="modal" data-target="#changeDoc4"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic4Basic!=''" (click)="deletePic('pic_4')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal4').modal('show');" *ngIf="pic4Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic4Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic4Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>	
													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 5    <a data-toggle="modal" data-target="#changeDoc5"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic5Basic!=''" (click)="deletePic('pic_5')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal5').modal('show');" *ngIf="pic5Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic5Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic5Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>										
													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 6    <a data-toggle="modal" data-target="#changeDoc6"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic6Basic!=''" (click)="deletePic('pic_6')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal6').modal('show');" *ngIf="pic6Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic6Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic6Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>	
													<div class="col-md-4">
														<div class="form-group mb-2">
															<label class="form-label">Picture 7    <a data-toggle="modal" data-target="#changeDoc7"><i class="btn btn-icon btn-success fa fa-pencil"></i></a><a *ngIf="pic7Basic!=''" (click)="deletePic('pic_7')"><i class="btn btn-icon btn-danger fa fa-times"></i></a></label>
															<div class="col-lg-6 col-sm-12 mt-2" onclick="$('#doc_detail_pic_modal7').modal('show');" *ngIf="pic7Basic!=''" style="cursor:pointer;">
																<div class="item7-card-img">
																	<img src="{{pic7Basic}}" alt="img" class="cover-image"  style="height:150px;width:150px;">   
																</div>
															</div>
															<input type="text" class="form-control" *ngIf="pic7Basic==''" value="Not Uploaded" style="border:1px solid red;" readonly>
														</div>
													</div>	
                                                                                                   
                                                </div>
												<button type="button" class="btn btn-primary text-white" (click)="checkImages()">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>



        <div class="card m-b-20">
        <div class="card-header click-show">
            <h3 class="card-title">Document Detail</h3><span class="plusminus">+</span>
        </div>
        <div class="card-body inspection-heading">
            <form [formGroup]="documentDynamicFormGroup" *ngIf="documentFromStatus">
                <div class="form-row" *ngFor="let item of documentXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0">
                            <div *ngIf="documentDynamicFormGroup.get('select_'+item.id).errors  && isDocumentInfoSubmit">  
                                <div *ngIf="documentDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                            </div>
                    </div>
                    <div class="form-group col-md-4" *ngIf="item.text=='date'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <input type="date" formControlName="text_{{item.id}}" class="form-control" id="text_{{item.id}}" placeholder="Select date">
                    </div>
                    <div class="form-group col-md-5" *ngIf="item.text=='text'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>

                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="documentDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                <div class=" col-sm-12 col-md-12"  *ngIf="inspectionEditStatus">
                        <button *ngIf="documentInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveDocumentDetail(documentDynamicFormGroup.value)">{{documentInfoSaveBtnLbl}}</button>
                        <button *ngIf="documentInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{documentInfoSaveBtnLbl}}...</button>
                </div>
            </form>            
        </div>
    </div>

    <div class="card m-b-20">
        <div class="card-header click-show">
            <h3 class="card-title">Exterior Front </h3><span class="plusminus">+</span>
        </div>
        <div class="card-body inspection-heading">
            <form [formGroup]="exteriorFrontDynamicFormGroup" *ngIf="exteriorFrontFromStatus">
                <div class="form-row" *ngFor="let item of exteriorFrontXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0">
                            <div *ngIf="exteriorFrontDynamicFormGroup.get('select_'+item.id).errors  && isExteriorInfoSubmit">  
                                <div *ngIf="exteriorFrontDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>

                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="exteriorFrontDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                <div class=" col-sm-12 col-md-12"  *ngIf="inspectionEditStatus">
                        <button *ngIf="exteriorInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveExteriorFrontDetail(exteriorFrontDynamicFormGroup.value)">{{exteriorInfoSaveBtnLbl}}</button>
                        <button *ngIf="exteriorInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{exteriorInfoSaveBtnLbl}}...</button>
                </div>
            </form>            
        </div>
    </div>

    <div class="card m-b-20">
        <div class="card-header click-show">
            <h3 class="card-title">Exterior Others </h3><span class="plusminus">+</span>
        </div>
        <div class="card-body inspection-heading">
            <form [formGroup]="exteriorOtherDynamicFormGroup"  *ngIf="exteriorOtherFromStatus">
                    <div class="form-row" *ngFor="let item of exteriorOtherXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0">
                            <div *ngIf="exteriorOtherDynamicFormGroup.get('select_'+item.id).errors  && isExteriorOtherInfoSubmit">  
                                <div *ngIf="exteriorOtherDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>    
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>
                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="exteriorOtherDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                        <button *ngIf="exteriorOtherInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveExteriorOtherDetail(exteriorOtherDynamicFormGroup.value)">{{exteriorOtherInfoSaveBtnLbl}}</button>
                        <button *ngIf="exteriorOtherInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{exteriorOtherInfoSaveBtnLbl}}...</button>
                    </div> 
            </form>
        </div>
    </div>

    <div class="card m-b-20">
        <div class="card-header click-show">
            <h3 class="card-title">Tyres</h3><span class="plusminus">+</span>
        </div>
        <div class="card-body inspection-heading">
            <form [formGroup]="tyresDynamicFormGroup"  *ngIf="tyresFromStatus">
                    <div class="form-row" *ngFor="let item of tyresXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length >0 ? 'block' : 'none'">    
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                         
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            required 
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="tyresDynamicFormGroup.get('select_'+item.id).errors  && isTyresInfoSubmit">  
                                <div *ngIf="tyresDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>     
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>
                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="tyresDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                        <button *ngIf="tyresInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveTyresDetail(tyresDynamicFormGroup.value)">{{tyresInfoSaveBtnLbl}}</button>
                        <button *ngIf="tyresInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{tyresInfoSaveBtnLbl}}...</button>
                    </div> 
            </form>
        </div>
    </div>

    <div class="card m-b-20">
        <div class="card-header click-show">
            <h3 class="card-title w-100">Engine + Transmission</h3><span class="plusminus">+</span>
        </div>
        <div class="card-body inspection-heading">
            <form [formGroup]="engineDynamicFormGroup"  *ngIf="engineFromStatus">
                    <div class="form-row" *ngFor="let item of engineXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0"> 
                                <div *ngIf="engineDynamicFormGroup.get('select_'+item.id).errors  && isEngineInfoSubmit">  
                                    <div *ngIf="engineDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                        <span style="color: red;">Select value</span>  
                                    </div> 
                                </div>
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>
                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="engineDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                        <button *ngIf="engineInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveEngineDetail(engineDynamicFormGroup.value)">{{engineInfoSaveBtnLbl}}</button>
                        <button *ngIf="engineInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{engineInfoSaveBtnLbl}}...</button>
                    </div> 
            </form>
        
    </div>
</div>
<div class="card m-b-20 ">
    <div class="card-header click-show">
        <h3 class="card-title">Engine Sound Video </h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form [formGroup]="otherInspectionFormGroup">
                    <div class="form-row">                     
                  <hr class="hr">                  
                        <!-- <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Other Exterior Accessories Detail</label>
                                <textarea formControlName="otherExterior" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>	

                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Other Tyres Detail</label>
                                <textarea formControlName="otherTyres" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>	
                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Other Engine Detail</label>
                                <textarea formControlName="otherEngine" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Other Air Conditioning Detail</label>
                                <textarea formControlName="otherAc" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Other Interior Detail</label>
                                <textarea formControlName="otherInterior" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Other Steering/Suspension/Brakes Detail</label>
                                <textarea formControlName="otherSSB" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Battery</label>
                                <textarea formControlName="otherBattery" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-md-4"  style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Battery Year</label>
                                <textarea formControlName="otherBatteryYear" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-md-4" style="display:none">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Battery Make</label>
                                <textarea formControlName="otherBatteryMake" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                            </div>
                        </div> -->
                        <div class="form-group col-md-5">
                            <div class="form-group">
                                <label class="form-label" for="exampleInputEmail1">Engine Sound Video</label>
                                <div class="item7-card-img  ">
                                <div class="thumb" *ngIf="otherEngineSoundVideo!=''">
                                <video controls>
                                <source src="{{otherEngineSoundVideo}}" type="video/webm">
                                <source src="{{otherEngineSoundVideo}}" type="video/mp4">
                                <p>This browser does not support the video element.</p>
                                </video>
                                </div>
                                </div>
                                <input type="file" formControlName="otherEngineSoundVideo" (change)="otherInspectionEngineSoundVideoChange($event)" accept="video/*" class="form-control" class="cover-image">
                            </div>
                        </div>                    
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                        <button *ngIf="otherInspectionInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveOtherInspectionDetail(otherInspectionFormGroup.value)">{{otherInspectionInfoSaveBtnLbl}}</button>
                        <button *ngIf="otherInspectionInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{otherInspectionInfoSaveBtnLbl}}...</button>
                    </div>
                    </div>
            </form>
	</div>
    
</div>
<div class="card m-b-20">
    <div class="card-header click-show">
        <h3 class="card-title">Air Conditioning</h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form [formGroup]="aCDynamicFormGroup"  *ngIf="aCFromStatus">
                    <div class="form-row" *ngFor="let item of aCXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0">
                            <div *ngIf="aCDynamicFormGroup.get('select_'+item.id).errors  && isACInfoSubmit">  
                                <div *ngIf="aCDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>
                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="aCDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                        <button *ngIf="aCInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveAcDetail(aCDynamicFormGroup.value)">{{aCInfoSaveBtnLbl}}</button>
                        <button *ngIf="aCInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{aCInfoSaveBtnLbl}}...</button>
                    </div> 
            </form>
    </div>
</div>
<div class="card m-b-20">
    <div class="card-header click-show">
        <h3 class="card-title">Electricals + Interiors</h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form [formGroup]="interiorDynamicFormGroup"  *ngIf="interiorFromStatus">
                    <div class="form-row" *ngFor="let item of interiorXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0">
                            <div *ngIf="interiorDynamicFormGroup.get('select_'+item.id).errors  && isInteriorInfoSubmit">  
                                <div *ngIf="interiorDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>
                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="interiorDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                    <button *ngIf="interiorInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveInteriorDetail(interiorDynamicFormGroup.value)">{{interiorInfoSaveBtnLbl}}</button>
                    <button *ngIf="interiorInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{interiorInfoSaveBtnLbl}}...</button>
                     </div> 
            </form>
    </div>
</div>

<div class="card m-b-20 ">
    <div class="card-header click-show">
        <h3 class="card-title">Steering + Suspension + Brakes </h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form [formGroup]="sSBDynamicFormGroup"  *ngIf="sSBFromStatus">
                    <div class="form-row" *ngFor="let item of sSBXML">                     
                  <hr class="hr">
                    <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                        <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                        <ng-select 
                            name="id" 
                            [multiple]="true"
                            [items]="item.optionList" 
                            formControlName="select_{{item.id}}"                               
                            bindValue="id" 
                            bindLabel="name" 
                            placeholder="Select"
                            [closeOnSelect]="false">
                            </ng-select>
                            <div *ngIf="item.optionList.length>0">
                            <div *ngIf="sSBDynamicFormGroup.get('select_'+item.id).errors  && isSSBInfoSubmit">  
                                <div *ngIf="sSBDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                                    <span style="color: red;">Select value</span>  
                                </div> 
                            </div>
                            </div>
                    </div>
                    <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                        <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                        <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
                    </div>
                    <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                        <div class="item7-card-img">
                            <div class="thumb" *ngIf="item.image!=''">
                            <img src="{{item.image}}" />
                            </div>
                            <input type="file" accept="image/*" (change)="sSBDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                        </div>
                    </div>
                </div>
                    <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                        <button *ngIf="sSBInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveSsbDetail(sSBDynamicFormGroup.value)">{{sSBInfoSaveBtnLbl}}</button>
                        <button *ngIf="sSBInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{sSBInfoSaveBtnLbl}}...</button>
                    </div>
            </form>
	</div>
    
</div>


<div class="card m-b-20 ">
    <div class="card-header click-show">
        <h3 class="card-title">Cooling System </h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form [formGroup]="coolingSystemDynamicFormGroup"  *ngIf="coolingSystemFromStatus">
            <div class="form-row" *ngFor="let item of coolingSystemXML">                     
            <hr class="hr">
            <div class="form-group col-md-4" [style.display]="item.optionList.length>0 ? 'block' : 'none'">
                <label for="inputEmail4" class="form-label">{{item.name}}</label>                        
                <ng-select 
                    name="id" 
                    [multiple]="true"
                    [items]="item.optionList" 
                    formControlName="select_{{item.id}}"                               
                    bindValue="id" 
                    bindLabel="name" 
                    placeholder="Select"
                    [closeOnSelect]="false">
                    </ng-select>
                    <div *ngIf="item.optionList.length>0">
                    <div *ngIf="coolingSystemDynamicFormGroup.get('select_'+item.id).errors  && isCoolingSystemInfoSubmit">  
                        <div *ngIf="coolingSystemDynamicFormGroup.get('select_'+item.id).hasError('required')">  
                            <span style="color: red;">Select value</span>  
                        </div> 
                    </div>
                    </div>
            </div>
            <div class="form-group col-md-5" [style.display]="item.text=='true' ? 'block' : 'none'">
                <label *ngIf="item.optionList.length==0" for="inputEmail4" class="form-label">{{item.name}}</label>
                <textarea formControlName="text_{{item.id}}" rows="2" cols="4" class="form-control" id="inputEmail5" placeholder="Details if any"></textarea>
            </div>
            <div class="form-group col-md-3"  [style.display]="item.pic=='true' ? 'block' : 'none'">
                <div class="item7-card-img">
                    <div class="thumb" *ngIf="item.image!=''">
                    <img src="{{item.image}}" />
                    </div>
                    <input type="file" accept="image/*" (change)="coolingSystemDynamicImageChange(item.id,$event)" class="form-control" class="cover-image">   
                </div>
            </div>
        </div>
        <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
            <button *ngIf="coolingSystemInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveCoolingSystemDetail(coolingSystemDynamicFormGroup.value)">{{sSBInfoSaveBtnLbl}}</button>
            <button *ngIf="coolingSystemInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{sSBInfoSaveBtnLbl}}...</button>
        </div>
    </form>
    </div>
</div>






<div class="card m-b-20 ">
    <div class="card-header click-show">
        <h3 class="card-title">Rating </h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form class="">
            <div class="form-row ">
                <div class=" col-md-12">


                    <div class="form-group col-md-12">
                        <div class="form-group start_icon">
                            Exterior + Tyres 

                            <i [ngClass]="{'active': exteriorTyres>0}" class="fa fa-star" (click)="ratingExteriorTyresChange(1)"></i>
                            <i [ngClass]="{'active': exteriorTyres>1}" class="fa fa-star" (click)="ratingExteriorTyresChange(2)"></i>
                            <i [ngClass]="{'active': exteriorTyres>2}" class="fa fa-star" (click)="ratingExteriorTyresChange(3)"></i>
                            <i [ngClass]="{'active': exteriorTyres>3}" class="fa fa-star" (click)="ratingExteriorTyresChange(4)"></i>
                            <i [ngClass]="{'active': exteriorTyres>4}" class="fa fa-star" (click)="ratingExteriorTyresChange(5)"></i> 
                        </div>
                    </div>	



                </div>
                <div class=" col-md-12">

                    <div class="form-group col-md-12">
                        <div class="form-group start_icon">
                            Engine + Transmission
                            <i [ngClass]="{'active': engineTransmission>0}" class="fa fa-star" (click)="ratingEngineTransmissionChange(1)"></i>
                            <i [ngClass]="{'active': engineTransmission>1}" class="fa fa-star" (click)="ratingEngineTransmissionChange(2)"></i>
                            <i [ngClass]="{'active': engineTransmission>2}" class="fa fa-star" (click)="ratingEngineTransmissionChange(3)"></i>
                            <i [ngClass]="{'active': engineTransmission>3}" class="fa fa-star" (click)="ratingEngineTransmissionChange(4)"></i>
                            <i [ngClass]="{'active': engineTransmission>4}" class="fa fa-star" (click)="ratingEngineTransmissionChange(5)"></i>  
                        </div>
                    </div>	
                </div>
                <div class=" col-md-12">

                    <div class="form-group col-md-12">
                        <div class="form-group start_icon">
                            Air Conditioning
                            <i [ngClass]="{'active': airConditioning>0}" class="fa fa-star" (click)="ratingAirConditionChange(1)"></i>
                            <i [ngClass]="{'active': airConditioning>1}" class="fa fa-star" (click)="ratingAirConditionChange(2)"></i>
                            <i [ngClass]="{'active': airConditioning>2}" class="fa fa-star" (click)="ratingAirConditionChange(3)"></i>
                            <i [ngClass]="{'active': airConditioning>3}" class="fa fa-star" (click)="ratingAirConditionChange(4)"></i>
                            <i [ngClass]="{'active': airConditioning>4}" class="fa fa-star" (click)="ratingAirConditionChange(5)"></i>  
                        </div>
                    </div>	
                </div>
                <div class=" col-md-12">

                    <div class="form-group col-md-12">
                        <div class="form-group start_icon">
                            Electricals + Interiors
                            <i [ngClass]="{'active': electricalsInteriors>0}" class="fa fa-star" (click)="ratingElectricalsInteriorsChange(1)"></i>
                            <i [ngClass]="{'active': electricalsInteriors>1}" class="fa fa-star" (click)="ratingElectricalsInteriorsChange(2)"></i>
                            <i [ngClass]="{'active': electricalsInteriors>2}" class="fa fa-star" (click)="ratingElectricalsInteriorsChange(3)"></i>
                            <i [ngClass]="{'active': electricalsInteriors>3}" class="fa fa-star" (click)="ratingElectricalsInteriorsChange(4)"></i>
                            <i [ngClass]="{'active': electricalsInteriors>4}" class="fa fa-star" (click)="ratingElectricalsInteriorsChange(5)"></i>  
                        </div>
                    </div>	
                </div>
                <div class=" col-md-12">

                    <div class="form-group col-md-12">
                        <div class="form-group start_icon">
                            Steering + Suspension + Brakes   
                            <i [ngClass]="{'active': steeringSuspensionBrakes>0}" class="fa fa-star" (click)="ratingSteeringSuspensionBrakesChange(1)"></i>
                            <i [ngClass]="{'active': steeringSuspensionBrakes>1}" class="fa fa-star" (click)="ratingSteeringSuspensionBrakesChange(2)"></i>
                            <i [ngClass]="{'active': steeringSuspensionBrakes>2}" class="fa fa-star" (click)="ratingSteeringSuspensionBrakesChange(3)"></i>
                            <i [ngClass]="{'active': steeringSuspensionBrakes>3}" class="fa fa-star" (click)="ratingSteeringSuspensionBrakesChange(4)"></i>
                            <i [ngClass]="{'active': steeringSuspensionBrakes>4}" class="fa fa-star" (click)="ratingSteeringSuspensionBrakesChange(5)"></i>  
                        </div>
                    </div>	
                </div>

            </div>


            <div class=" col-sm-12 col-md-12 "  *ngIf="inspectionEditStatus">
                <button *ngIf="ratingInfoSaveBtnLbl=='Save'" type="button" class="btn btn-primary text-white" (click)="saveRatingDetail()">{{ratingInfoSaveBtnLbl}}</button>
                <button *ngIf="ratingInfoSaveBtnLbl!='Save'" type="button" class="btn btn-primary text-white">{{ratingInfoSaveBtnLbl}}...</button>
            </div>
	</form>
    </div>
    
</div>

<div class="card m-b-20 ">
    <div class="card-header click-show">
        <h3 class="card-title">Highlights </h3><span class="plusminus">+</span>
    </div>
    <div class="card-body inspection-heading">
        <form class="">
            <div class="form-row ">
                <div class=" col-md-12">


                    <div class="form-group col-md-12">
                        <div class="form-group start_icon" *ngFor="let item of highlights"> 
                        {{item.name}}
                        </div>
                    </div>
                </div>              
             </div>
	</form>
    </div>
    
</div>
</div>

</div>





<!-- Change Doc model -->
<div id="changeDoc1" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_1')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->
<!-- Change Doc model -->
<div id="changeDoc2" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal" [formGroup]="loginFormGroup2">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_2')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->
<!-- Change Doc model -->
<div id="changeDoc3" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal" [formGroup]="loginFormGroup2">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_3')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->
<!-- Change Doc model -->
<div id="changeDoc4" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal" [formGroup]="loginFormGroup2">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_4')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->
<!-- Change Doc model -->
<div id="changeDoc5" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal" [formGroup]="loginFormGroup2">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_5')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->

<!-- Change Doc model -->
<div id="changeDoc6" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal" [formGroup]="loginFormGroup2">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_6')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->
<!-- Change Doc model -->
<div id="changeDoc7" class="modal fade in" role="dialog" style="z-index:9999; !important">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">                            
				<h4 class="modal-title">Upload</h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-body">                        
				<div class="form-row">
				<form class="form-horizontal" [formGroup]="loginFormGroup2">
					<label class="form-label">Upload Car Image</label>
					<input type="file" class="form-control" accept=".png, .PNG, .jpg, .JPG, .jpeg, JPEG" type="file" (change)="selectProfilePic($event)">
					<div class="form-row col-sm-12 col-md-12" style="margin-top:4%">
						<div class="form-group mb-0 row justify-content-end">
							<div class="col-md-3">
								<a  (click)="editPic('pic_7')" class="btn btn-primary waves-effect waves-light">Change</a>
							</div>
						</div>
					</div>
				</form>
				</div>                        
			</div>

		</div>
	</div>
</div>
<!--/App-Content-->











</section>
<!--/Faq section-->
<app-footer></app-footer>